export const TRIP_ACTION = {
    Hold: 2,
    Confirm: 3,
    Amend: 8,
};

export const PRODUCT_TYPE = {
    Flight: 1,
    Hotel: 2,
    Car: 3,
    EuRail: 4,
};

export const BOOKING_STATUS = {
    Booked: 1,
    Failed: 2,
    Unconfirmed: 3,
    NoLongerAvailable: 4,
    Duplicate: 5,
};

export const HOLDING_STATUS = {
    Failed: 2,
    NoLongerAvailable: 4,
};

export const PAYMENT_STATUS = {
    Successful: 1,
    Failure: 2,
    FailureTryAgain: 3,
    FailureOnlineHelpdesk: 4,
    InvalidCardNumber: 5,
    InvalidCardType: 6,
    InvalidCardDetails: 7,
    InvalidMinimumAmount: 8,
    InvalidMaximumAmount: 9,
    Invalid3DSecureEnrolled: 10,
    Invalid3DSecureSupport: 11,
    InvalidVisaPassword: 12,
    InvalidOnlineDisabled: 13,
    InvalidOnlineRestriction: 14,
};




// WEBPACK FOOTER //
// ./src/app/modules/trip/constants/trip-options.js